import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Panel } from '../../../../../Components/Panel/Panel';
import { AptorApi } from '../../../../../Api/AptorApi';
import { CreateInformationBoardForm } from './Create.Form';
import Loading from '../../../../../Components/Loading';
import { useOptions } from '.././Options';
import { FormValues } from '../../../../../Components/Form/Form.types';
import { Container, BackButton } from '../../../../../Components';
import { entityToSelectOption } from '../../../../../Utilities';
import { useIntl } from 'react-intl';

export const CreateInformationBoard = () => {
  const [options, loading] = useOptions();
  const navigate = useNavigate();
  const { formatMessage } = useIntl();
  const handleSubmit = async (form: FormValues, api: AptorApi, onSuccess: () => void) => {
   await api.createAnnouncements(form);
    onSuccess();
    navigate(`/admin/law-portal/information-board`);
  };

  const visible=[
     {
            "id": 1,
            "name": formatMessage({ id: 'admin.law-portal.informationboard.form.visible.onlyVisibleClintAdmin', defaultMessage: 'Only visible to Client Admin' })
        },
        {
            "id": 2,
            "name": formatMessage({ id: 'admin.law-portal.informationboard.form.visible.onlyVisibleUser', defaultMessage: 'Only visible to User' })
        },
        {
            "id": 3,
            "name": formatMessage({ id: 'admin.law-portal.informationboard.form.visible.visibleBoth', defaultMessage: 'Visible to both Client Admin and User' })
        }
  ].map(entityToSelectOption)

  return (
    (loading && <Loading />) || (
      <Container>
        <BackButton link="/admin/law-portal/information-board" />
        <Panel titleKey="" accordion={false}>
          <CreateInformationBoardForm submit={handleSubmit} visible={visible} />
        </Panel>
      </Container>
    )
  );
};